var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConvertIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 25,
    viewBox: "0 0 32 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.12848 1.82143L11.5769 11.4936M11.5769 11.4936L2.12848 23.1786M11.5769 11.4936L13.7257 13.6932C15.0063 14.8715 16.9938 14.8715 18.2745 13.6932L20.5333 11.4936M30.1667 2.11236L20.5333 11.4936M20.5333 11.4936L30.1667 22.8876M2.12848 23.1786C2.71608 23.6898 3.48797 24 4.33333 24H27.6667C28.6622 24 29.5558 23.5697 30.1667 22.8876M2.12848 23.1786C1.43647 22.5765 1 21.6956 1 20.7143V4.28571C1 2.47106 2.49238 1 4.33333 1H27.6667C29.5077 1 31 2.47106 31 4.28571V20.7143C31 21.5475 30.6853 22.3084 30.1667 22.8876",
    stroke: "#262429",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConvertIcon);
export default __webpack_public_path__ + "static/media/convertIcon.33d413db4b9fba4ceaae00d511db271f.svg";
export { ForwardRef as ReactComponent };